import React from "react";
import { useDispatch } from "react-redux";
import useCreate from "hooks/useCreate";
import Context from "./context";
import invariant from "invariant";
import { APIEndpoint } from "api";

export default function useExport(apiEndpoint, options) {
	invariant(apiEndpoint instanceof APIEndpoint, 'apiEndpoint is required');

	const dispatch = useDispatch();

	const _createExport = React.useCallback((data) => {
		dispatch(apiEndpoint.create({
			status: 'ready',
			...data,
		}, options));
	}, [apiEndpoint, options, dispatch]);

	const { watch } = React.useContext(Context);

	const createExport = useCreate({
		create: _createExport,
		creating: apiEndpoint.useCreating(),
		instance: apiEndpoint.useCurrentOrConflictFromState(),
		onCreate: (instance) => {
			// Register the export in the watch
			watch(apiEndpoint, instance, options);
		},
	});

	return { createExport };
};
